export default __webpack_public_path__ + "static/media/landing.e329f45f.png";